<template>
  <v-data-table
    :headers="headers"
    :items="transactionHistory"
    item-key="transactionLogId"
    :item-class="rowClass"
    class="elevation-1"
    :search="search"
    :loading="loading"
    :disable-sort="true"
    @update:page="tableProperties.page = $event"
    @update:items-per-page="tableProperties.itemsPerPage = $event"
  >
    <template v-slot:[`item.amount`]="{ item }">
      ${{ item.amount }} {{ item.currencyText }}</template
    >

    <template v-slot:[`item.transactionStatus`]="{ item }">
      <v-chip
        v-if="item.transactionStatus"
        :color="statusColour(item.transactionStatus)"
        dark
        >{{ statusText(item.transactionStatus) }}</v-chip
      >
    </template>

    <template v-slot:loading>
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </template>
  </v-data-table>
</template>
<style></style>
<script>
export default {
  props: {
    transactionHistory: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    transactionStatuses: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    search: {
      type: String,
      required: false,
      default: ""
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Date",
          value: "date"
        },
        {
          text: "Amount",
          value: "amount"
        },
        {
          text: "Status",
          value: "transactionStatus"
        }
      ],
      tableProperties: {
        page: 1,
        itemsPerPage: 10
      }
    };
  },
  watch: {
    shouldLoadMoreTransactions(newValue) {
      if (newValue) this.$emit("loadMoreTransactionHistory");
    }
  },
  computed: {
    totalTransactions() {
      return this.transactionHistory.length;
    },
    totalPages() {
      if (this.tableProperties.itemsPerPage === 0) return 0;
      return this.totalTransactions / this.tableProperties.itemsPerPage;
    },
    shouldLoadMoreTransactions() {
      if (this.totalPages == 0) return false;

      return this.tableProperties.page - this.totalPages >= 0;
    }
  },
  methods: {
    rowClass() {
      const rowClass = "table-rows";
      return rowClass;
    },
    statusColour(status) {
      return !!this.transactionStatuses[status]
        ? this.transactionStatuses[status].colour
        : "black";
    },
    statusText(status) {
      if (!status) return "";
      return !!this.transactionStatuses[status]
        ? this.transactionStatuses[status].name
        : status;
    }
  }
};
</script>

<style lang="scss" scoped></style>
